var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"highchart-container"},[_c('highcharts',{staticClass:"runtime-chart",attrs:{"options":_vm.runtimeGraphOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }